import React, { ReactNode } from 'react'
import { Popover } from '@base-ui/react/popover'
import './Tooltip.scss'

interface TooltipProps {
  content: string
  children: ReactNode
}

export const Tooltip = ({ content, children }: TooltipProps) => (
  <Popover.Root modal={false}>
    <Popover.Trigger
      render={<span className='tooltip-trigger'/>}
      nativeButton={false}
      openOnHover
      delay={200}
      closeDelay={100}
    >
      {children}
    </Popover.Trigger>
    <Popover.Portal>
      <Popover.Positioner side='bottom' align='start' sideOffset={8} className='tooltip-positioner'>
        <Popover.Popup className='tooltip-popup' role='tooltip' initialFocus={false}>
          {content}
        </Popover.Popup>
      </Popover.Positioner>
    </Popover.Portal>
  </Popover.Root>
)
